import { type SecondaryNavGroup } from '.'
import { BeakerIcon, CruxIcon, ProfileIcon, TeamIcon, OfficeIcon, CogIcon } from '../../Icon'

export const NAV_WIDTH_EXPANDED = '230px'
export const NAV_WIDTH_COLLAPSED = '60px'
export const NAV_TRANSITION_DURATION = 150

export const NON_CUSTOMER_SINGLE_PAGE_TEST_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'single_page_test.navigation.links.synthetic',
    icon: BeakerIcon,
    children: [
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.overview',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/overview`,
        highlightMatches: ['/tests/:uuid/:shareToken/overview']
      },
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.lighthouse',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/lighthouse`,
        highlightMatches: ['/tests/:uuid/:shareToken/lighthouse/*', '/tests/:uuid/:shareToken/lighthouse']
      },
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.third_party',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/third-parties`,
        highlightMatches: ['/tests/:uuid/:shareToken/third-parties']
      },
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.monitoring',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/monitoring`,
        highlightMatches: ['/tests/:uuid/:shareToken/monitoring']
      }
    ]
  },
  {
    labelId: 'single_page_test.navigation.links.crux',
    icon: CruxIcon,
    children: [
      {
        labelId: 'single_page_test.navigation.links.crux.children.dashboard',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/crux/dashboard`,
        highlightMatches: ['/tests/:uuid/:shareToken/crux/dashboard']
      },
      {
        labelId: 'single_page_test.navigation.links.crux.children.pages',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/crux/pages`,
        highlightMatches: ['/tests/:uuid/:shareToken/crux/pages']
      }
    ]
  }
]

export const CUSTOMER_SINGLE_PAGE_TEST_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'single_page_test.navigation.links.synthetic',
    icon: BeakerIcon,
    children: [
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.overview',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/overview`,
        highlightMatches: ['/tests/:uuid/:shareToken/overview']
      },
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.lighthouse',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/lighthouse`,
        highlightMatches: ['/tests/:uuid/:shareToken/lighthouse/*', '/tests/:uuid/:shareToken/lighthouse']
      },
      {
        labelId: 'single_page_test.navigation.links.synthetic.children.third_party',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/third-parties`,
        highlightMatches: ['/tests/:uuid/:shareToken/third-parties']
      }
    ]
  },
  {
    labelId: 'single_page_test.navigation.links.crux',
    icon: CruxIcon,
    children: [
      {
        labelId: 'single_page_test.navigation.links.crux.children.dashboard',
        to: ({ uuid, shareToken }) => `/tests/${uuid}/${shareToken}/crux/dashboard`,
        highlightMatches: ['/tests/:uuid/:shareToken/crux/dashboard']
      }
    ]
  }
]

export const USER_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'navigation.links.profile',
    icon: ProfileIcon,
    children: [
      {
        labelId: 'navigation.links.profile.children.general',
        to: () => '/you/settings/profile'
      },
      {
        labelId: 'navigation.links.profile.children.notifications',
        to: () => '/you/settings/email-notifications'
      },
      {
        labelId: 'navigation.links.profile.children.applications',
        to: () => '/you/settings/applications'
      },
      {
        labelId: 'navigation.links.profile.children.accessTokens',
        to: () => '/you/settings/tokens',
        highlightMatches: ['/you/settings/tokens/*', '/you/settings/tokens']
      }
    ]
  }
]

export const ORGANISATION_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'navigation.links.organisation',
    icon: OfficeIcon,
    children: [
      {
        labelId: 'navigation.links.organisation.children.people',
        to: ({ orgId }) => `/organisations/${orgId}/members`,
        highlightMatches: [
          '/organisations/:orgId/members/*',
          '/organisations/:orgId/members',
          '/organisations/:orgId/edit'
        ],
        permission: 'updateOrganisations'
      },
      {
        labelId: 'navigation.links.organisation.children.teams',
        to: ({ orgId }) => `/organisations/${orgId}/teams`,
        highlightMatches: ['/organisations/:orgId/teams/*', '/organisations/:orgId/teams'],
        permission: 'updateOrganisations'
      },
      {
        labelId: 'navigation.links.organisation.children.api',
        to: ({ orgId }) => `/organisations/${orgId}/api`,
        highlightMatches: ['/organisations/:orgId/api/*', '/organisations/:orgId/api'],
        permission: 'updateOrganisations'
      },
      {
        labelId: 'navigation.links.organisation.children.billing',
        to: ({ orgId }) => `/organisations/${orgId}/billing`,
        highlightMatches: ['/organisations/:orgId/billing/*', '/organisations/:orgId/billing'],
        permission: 'updateOrganisations'
      },
      {
        labelId: 'navigation.links.organisation.children.integrations',
        to: ({ orgId }) => `/organisations/${orgId}/integrations`,
        highlightMatches: ['/organisations/:orgId/integrations'],
        permission: 'updateOrganisations'
      },
      {
        labelId: 'navigation.links.organisation.children.settings',
        to: ({ orgId }) => `/organisations/${orgId}/settings`,
        highlightMatches: ['/organisations/:orgId/settings'],
        permission: 'updateOrganisations'
      }
    ]
  }
]

export const TEAM_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'navigation.links.team',
    icon: TeamIcon,
    children: [
      {
        labelId: 'navigation.links.sites',
        to: ({ teamId }) => `/teams/${teamId}/sites`,
        highlightMatches: ['/teams/:teamId/sites/new', '/teams/:teamId/sites']
      },
      {
        labelId: 'navigation.links.members',
        to: ({ teamId }) => `/teams/${teamId}/team`,
        highlightMatches: ['/teams/:teamId/team/add', '/teams/:teamId/team']
      }
    ]
  }
]

export const SITE_LINKS: SecondaryNavGroup[] = [
  {
    labelId: 'navigation.links.synthetic',
    icon: BeakerIcon,
    children: [
      {
        labelId: 'navigation.links.synthetic.children.pulse',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/pulse`,
        highlightMatches: ['/teams/:orgId/:siteId/metrics/*', '/teams/:orgId/:siteId'],
        permission: 'readSites'
      },
      {
        labelId: 'navigation.links.synthetic.children.pages',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/pages`,
        permission: 'readSites'
      },
      {
        labelId: 'navigation.links.synthetic.children.snapshots',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/snapshots`,
        permission: 'readSites',
        highlightMatches: ['/teams/:teamId/:siteId/snapshots/*', '/teams/:teamId/:siteId/snapshots/']
      },
      {
        labelId: 'navigation.links.synthetic.children.budgets',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/budgets`,
        permission: 'readSites',
        highlightMatches: ['/teams/:teamId/:siteId/budgets/*', '/teams/:teamId/:siteId/budgets']
      },
      {
        labelId: 'navigation.links.synthetic.children.settings',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/settings/synthetic`,
        highlightMatches: [
          '/teams/:teamId/:siteId/settings/synthetic/agent',
          '/teams/:teamId/:siteId/settings/synthetic/authentication',
          '/teams/:teamId/:siteId/settings/synthetic/profiles/*',
          '/teams/:teamId/:siteId/settings/synthetic/profiles',
          '/teams/:teamId/:siteId/settings/synthetic/integrations/*',
          '/teams/:teamId/:siteId/settings/synthetic/integrations'
        ],
        permission: 'updateSites'
      }
    ]
  },
  {
    labelId: 'navigation.links.crux',
    icon: CruxIcon,
    children: [
      {
        labelId: 'navigation.links.crux.children.dashboard',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/crux/dashboard`,
        permission: 'readSites'
      },
      {
        labelId: 'navigation.links.crux.children.pages',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/crux/pages`,
        permission: 'readSites'
      }
    ]
  },
  {
    labelId: 'navigation.links.siteSettings',
    icon: CogIcon,
    children: [
      {
        labelId: 'navigation.links.siteSettings.children.general',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/settings/general`,
        permission: 'updateSites',
        highlightMatches: ['/teams/:teamId/:siteId/settings']
      },
      {
        labelId: 'navigation.links.siteSettings.children.pages',
        to: ({ teamId, siteId }) => `/teams/${teamId}/${siteId}/settings/pages`,
        permission: 'updateSites',
        highlightMatches: ['/teams/:teamId/:siteId/settings/pages/*', '/teams/:teamId/:siteId/settings/pages']
      }
    ]
  }
]
